import { SizeUnitType } from '@meitu/saas-editor-core/es/utils/unit-kit';
import { getLocaleStore } from '@/i18n';
import { ListType } from '@/services/size-list/index.d';

// 自定义尺寸列表id
export const CUSTOM_SIZE_ID = -20;
// 原始尺寸列表id
export const ORIGIN_SIZE_ID = -10;

//尺寸列表title
export const TITLE_SIZE_ID = -99;

export const handleSizeListStructure = (list: ListType[], recommendDefaultList: ListType[] = []) => {
    const recommendList: ListType[] = list;

    recommendList.unshift(...[getRecommendTitle(), ...recommendDefaultList]);
    return [...recommendList];
};

export const getCustomUnit = () => {
    const { $t } = getLocaleStore();

    return {
        default_name: $t((v) => v.panel.backgroundPanel.customSize),
        width: 0,
        height: 0,
        id: CUSTOM_SIZE_ID,
        isCheck: false,
        unit: SizeUnitType.px,
    };
};

export const getCustomTitle = () => {
    const { $t } = getLocaleStore();
    return {
        default_name: $t((v) => v.panel.backgroundPanel.customSizeTitle),
        width: 0,
        height: 0,
        id: TITLE_SIZE_ID,
        isCheck: false,
        unit: SizeUnitType.px,
    };
};
export const getRecommendTitle = () => {
    const { $t } = getLocaleStore();
    return {
        default_name: $t((v) => v.panel.backgroundPanel.recommendSizeTitle),
        width: 0,
        height: 0,
        id: TITLE_SIZE_ID,
        isCheck: false,
        unit: SizeUnitType.px,
    };
};
